import { lazy } from "react"

export const CustomerById = lazy(() => import("./CustomerById"))
